import React from 'react';

import { AsyncComponent } from '../../index';

import * as PodcastActions from './actions';
import PodcastProgramRowGrid from './components/common/PodcastRowGrid/PodcastProgramRowGrid';
import * as PodcastConstants from './constants';
import * as D from './deps';
import PodcastReducer from './reducer';
import PodcastSagas from './sagas';
import * as PodcastUtils from './utils';

export default D.createDomainModule({
  name: 'podcast',
  actions: PodcastActions,
  utils: PodcastUtils,
  constants: PodcastConstants,
  components: {
    BackstagePodcastProgram: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-program" */ './components/pages/BackstagePodcastProgram/BackstagePodcastProgram',
            )
          }
        />
      );
    },
    BackstagePodcastProgramDescription: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-program-description" */ './components/pages/BackstagePodcastProgram/BackstagePodcastProgramDescription',
            )
          }
        />
      );
    },
    BackstagePodcastProgramMainContent: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-program-main-content" */ './components/pages/BackstagePodcastProgram/BackstagePodcastProgramMainContent',
            )
          }
        />
      );
    },
    BackstagePodcastProgramFullDescription: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-program-full-description" */ './components/pages/BackstagePodcastProgramFullDescription/BackstagePodcastProgramFullDescription',
            )
          }
        />
      );
    },

    BackstagePodcastEpisode: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-episode" */ './components/pages/BackstagePodcastEpisode/BackstagePodcastEpisode',
            )
          }
        />
      );
    },
    BackstagePodcastEpisodeDescription: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-episode-description" */ './components/pages/BackstagePodcastEpisode/BackstagePodcastEpisodeDescription',
            )
          }
        />
      );
    },
    BackstagePodcastEpisodeMainContent: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-episode-main-content" */ './components/pages/BackstagePodcastEpisode/BackstagePodcastEpisodeMainContent',
            )
          }
        />
      );
    },
    BackstagePodcastEpisodeFullDescription: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-episode-full-description" */ './components/pages/BackstagePodcastEpisodeFullDescription/BackstagePodcastEpisodeFullDescription',
            )
          }
        />
      );
    },

    BackstagePodcastProgramAllEpisodes: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-program-all-episodes" */ './components/pages/BackstagePodcastProgramAllEpisodes/BackstagePodcastProgramAllEpisodes',
            )
          }
        />
      );
    },
    BackstagePodcastProgramAllThumbs: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-program-all-thumbs" */ './components/pages/BackstagePodcastProgramAllThumbs/BackstagePodcastProgramAllThumbs',
            )
          }
        />
      );
    },

    PodcastCategoryGridItem: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_podcast-category-grid-item" */ './components/common/PodcastCategoryGridItem',
            )
          }
        />
      );
    },
    BackstagePodcastMoreFromCategory: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-more-from-category" */ './components/common/BackstagePodcastMoreFromCategory',
            )
          }
        />
      );
    },
    BackstagePodcastSidebarButtons: props => {
      return (
        <AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-podcast-program-sidebar-buttons" */ './components/common/BackstagePodcastSidebarButtons',
            )
          }
        />
      );
    },
    PodcastProgramRowGrid: props => <PodcastProgramRowGrid {...props} />,
  },
  selectors: {},
  reducer: PodcastReducer,
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(PodcastSagas);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
